import { useGrowthbook } from '@experience/core-hostapp-share-lib';
import { computed } from 'vue';

export const exposureKey = 'listing_labels_v4';

const LABELS_LIMIT_BY_FEATURE_VALUE: Record<number, number> = {
  1: 2,
  2: 4,
};

export const useListingLabelsV4Experiment = () => {
  const gb = useGrowthbook();

  const featureValue = computed(() => Number(gb?.getFeatureValue(exposureKey, 0) ?? 0));
  const listingLabelsLimit = computed(() => LABELS_LIMIT_BY_FEATURE_VALUE[featureValue.value] ?? 0);
  const isListingLabelsV4ExperimentActive = computed(() => listingLabelsLimit.value > 0);

  const getVisibleListingLabels = <T>(labels?: T[]) => {
    if (!listingLabelsLimit.value) {
      return undefined;
    }

    return labels?.slice(0, listingLabelsLimit.value);
  };

  return {
    featureValue,
    isListingLabelsV4ExperimentActive,
    listingLabelsLimit,
    getVisibleListingLabels,
  };
};
